(function () {
	angular.module('meanApp').controller('recipeCtrl', recipeCtrl);

	recipeCtrl.$inject = [
		'$scope',
		'$location',
		'authentication',
		'currentUser',
		'loginModal',
		'context',
		'$uibModal',
		'recipesManager',
		'ingredientsManager',
		'measuresManager',
		'Recipe',
		'alert',
		'$state'
	];
	function recipeCtrl(
		$scope,
		$location,
		authentication,
		currentUser,
		loginModal,
		context,
		$uibModal,
		recipesManager,
		ingredientsManager,
		measuresManager,
		Recipe,
		alert,
		$state
	) {
		//first thing to do check if user is connected or not
		currentUser.get().then(
			function (userModel) {
				console.log('ok user connected');
				if (!userModel._id) {
					//hack so if user wants to create a recipe he needs to be logged first
					//then go back to previous context
					loginModal.open(true);
					//history.back();
					if (document.referrer.includes(location.hostname)) {
						history.back();
					} else {
						console.log("Pas de retour possible dans le même site");
						window.location.href = "/";
					}
				}
			},
			function () {
				console.log('user not connected for recipe creation go back to home, then go back to profile');
				loginModal.open(true);
				//history.back();
				if (document.referrer.includes(location.hostname)) {
					history.back();
				} else {
					console.log("Pas de retour possible dans le même site");
					window.location.href = "/";
				}
			}
		);

		var vm = this;
		vm.COMPLETION_STEP = 100 / 5;
		vm.realCompletion = 5;
		vm.currentCompletion = 5;
		var INGREDIENTS_COLORS = [
			'#F49AC2',
			'#CB99C9',
			'#C23B22',
			'#FFD1DC',
			'#DEA5A4',
			'#AEC6CF',
			'#77DD77',
			'#B39EB5',
			'#FFB347',
			'#B19CD9',
			'#FF6961',
			'#03C03C',
			'#FDFD96',
			'#779ECB',
			'#966FD6'
		];

		vm.completionFeatures = [];
		vm.currentPosition = 1;

		vm.widthProgressBar = {
			width: vm.currentCompletion + '%'
		};

		vm.recipe = {
			needsFridge: false, //default value
			ingredientsQuantity: [],
			unknownIngredientsQuantity: [],
			instructions: []
		};

		//in this case we are in the edit of a recipe
		if ($state.params.id) {
			recipesManager.get($state.params.id, true).then(
				function (result) {
					vm.recipe = result;
					//clean removed ingredients in database (by precaution)
					vm.recipe.ingredientsQuantity = vm.recipe.ingredientsQuantity.filter(function (ingredientQuantity) {
						return ingredientQuantity.ingredient;
					});

					//console.log(vm.recipe.ingredientQuantity[0].ingredient.getThumb('xs'));
					vm.currentPosition = vm.recipe.instructions.length ? vm.recipe.instructions.length : 1;
					//now parse the recipe
					//convert the needsbaking or heating + bakingtypes + temps de preparation
					if (vm.recipe.unknownIngredientsQuantity) {
						vm.loadMeasures();
					}
					if ($state.params.step === '1') {
						vm.needsHeat = !!vm.recipe.bakingTime;
						if (vm.needsHeat) {
							//TODO change bakingType for bakingTypeSSSSSS
							vm.recipe.bakingType.forEach(function (bakingMethod) {
								vm.bakingTypes[bakingMethod] = true;
							});
						}

						vm.onHeatChange();
						vm.addCompletionFeature('picture');
						vm.onTitleChange();
						vm.onTypeChange();
						vm.onPeopleChange();
						vm.onBakingTimeChange();
						vm.onBakingTypesChange();
						if (vm.recipe.numberOfMinutes) {
							vm.addCompletionFeature('minutes');
						}
					}
				},
				function (err) {
					console.log('error loading the ingredient');
				}
			);
		}

		//default size or editor
		$scope.pixelSideEditor = {
			width: '100px',
			height: '100px'
		};
		$scope.imageSource = '';
		$scope.myCroppedImage = '';
		//$scope.pictureUploading = false;
		$scope.myAeraType = 'square';
		$scope.resultImageSize = 600;

		var setOptimizedWidthAndHeight = function (width, height) {
			//compute a square but not larger than 400px max
			var minSide = Math.min(width, height),
				minSideIsWidth = minSide === width,
				effectiveSide = 100,
				effectiveHeight,
				effectiveWidth;

			if (minSide > 400) {
				effectiveSide = 400;
			} else if (minSide > 100) {
				effectiveSide = minSide;
			}

			if (!minSideIsWidth) {
				effectiveWidth = effectiveSide;
				effectiveHeight = parseInt(effectiveWidth * height / width, 10);
			} else {
				effectiveHeight = effectiveSide;
				effectiveWidth = parseInt(width * effectiveHeight / height, 10);
			}

			var widthAvailable = window.document.getElementsByClassName('website-container')[0].offsetWidth - 20; //remove the margins

			//regulate the width
			if (widthAvailable < effectiveWidth) {
				effectiveWidth = widthAvailable;
				effectiveHeight = parseInt(height * effectiveWidth / width);
			}

			$scope.pixelSideEditor = {
				width: effectiveWidth + 'px',
				height: effectiveHeight + 'px'
			};
		};

		$scope.onFileChange = function (imageSource, width, height) {
			vm.addCompletionFeature('picture');
			$scope.imageSource = imageSource;
			console.log('image width is ' + width, 'height', height);

			setOptimizedWidthAndHeight(width, height);

			//here open a modal in order to edit the picture
			$scope.modal = $uibModal.open({
				templateUrl: 'profile/change.picture.modal.view.html',
				scope: $scope,
				backdrop: 'static'
			});

			$scope.modal.rendered.then(function () {
				console.log('modal change picture is rendered');
				//this.document.body.get modal-content
				var widthAvailable = window.document.getElementsByClassName('modal-content')[0].offsetWidth - 20;
				//what if prortrait image ?
				if (widthAvailable < width) {
					$scope.pixelSideEditor = {
						width: widthAvailable + 'px',
						height: parseInt(height * widthAvailable / width) + 'px'
					};
					//$scope.$apply();
				}
			});
		};

		var dataURLtoFile = function (dataurl, filename) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);

			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		};

		//TODO rename the function to someone more generic
		$scope.saveProfilePicture = function () {
			var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'recipe'),
				fd = new FormData();
			fd.append('file', fileBuiltFromeBase64); //pass the file newly created

			/**Object.keys(vm.recipe).forEach(function(key) {
				fd.append(key, JSON.stringify((vm.recipe[key])));
			});**/
			console.log($scope, this);
			//$scope.pictureUploading = true;
			//this.pictureUploading = true;
			console.log('the filename is', fileBuiltFromeBase64.filename);
			//put the button in loading mode

			console.log('the recipe object is', vm.recipe);
			if (vm.recipe._id) {
				//save using PUT with just the image
				vm.recipe.updateWithPicture(fd).then(function (recipe) {
					//then get the ID and put it into the recipe object :)
					//angular.extend(vm.recipe, recipe);
					//vm.recipe = recipe;
					//console.log('thumb construction', vm.recipe.getThumb('s'));

					this.modal.close();
					alert.push('success', 'Image sauvegardée');
				}.bind(this), function (error) {
					//TOOD préciser si déja en base de données ou quoi
					alert.push('danger', "Votre image n'a pu être sauvegardée");
				});
			} else {
				//create and POST the recipe
				//TODO transform the recipe in a suitable structure for the API
				var newRecipe = new Recipe(vm.recipe); //pass the parameters as init
				newRecipe.saveAsDraft(fd).then(function (recipe) {
					//then get the ID and put it into the recipe object :)
					//angular.extend(vm.recipe, recipe);
					vm.recipe = recipe;
					console.log('thum construction', vm.recipe.getThumb('s'));

					this.modal.close();
					alert.push('success', 'Image sauvegardée');
				}.bind(this), function (error) {
					//TOOD préciser si déja en base de données ou quoi
					alert.push('danger', "Votre image n'a pu être sauvegardée");
				});
			}
		};

		vm.bakingTypes = {
			MICROWAVE: false,
			HOB: false,
			OVEN: false
		};

		vm.recipe.numberOfMinutes = 0; //it can't be 0
		vm.sliderOptions = {
			//bindIndexForStepsArray : true,
			stepsArray: [
				{
					value: '0'
				},
				{
					value: '5'
				},
				{
					value: '15'
				},
				{
					value: '30'
				},
				{
					value: '45'
				},
				{
					value: '60'
				},
				{
					value: '90'
				},
				{
					value: '90+'
				}
			],
			onChange: function () {
				if (parseInt(vm.recipe.numberOfMinutes)) {
					vm.addCompletionFeature('minutes');
				} else {
					vm.removeCompletionFeature('minutes');
				}
			}
		};

		vm.typeOptions = [
			{
				name: 'Entrée',
				_id: 'ENTRY'
			},
			{
				name: 'Plat principal',
				_id: 'MAIN'
			},
			{
				name: 'Dessert',
				_id: 'DESSERT'
			},
			{
				name: 'Apéritif',
				_id: 'APERITIF'
			},
			{
				name: 'Boisson',
				_id: 'DRINK'
			},
			{
				name: 'Sauce',
				_id: 'SAUCE'
			}
		];

		vm.onHeatChange = function () {
			if (vm.needsHeat === true) {
				vm.COMPLETION_STEP = 100 / 7;
			} else {
				//TODO remove here the 2 things from completion features
				vm.COMPLETION_STEP = 100 / 5;
				//reinit the value for baking types and baking time
				vm.recipe.bakingTime = 0;
				vm.bakingTypes = {
					MICROWAVE: false,
					HOB: false,
					OVEN: false
				};
				vm.removeCompletionFeature('bakingTime');
				vm.removeCompletionFeature('bakingType');
			}
			vm.recomputeCompletion();
		};

		vm.onBakingTimeChange = function () {
			if (vm.recipe.bakingTime) {
				vm.addCompletionFeature('bakingTime');
			} else {
				vm.removeCompletionFeature('bakingTime');
			}
		};

		vm.onPeopleChange = function () {
			if (vm.recipe.numberOfPeople) {
				vm.addCompletionFeature('numberOfPeople');
			} else {
				vm.removeCompletionFeature('numberOfPeople');
			}
		};

		vm.onBakingTypesChange = function () {
			//TODO maybe set here a new
			var isSomeValueSet = false;
			vm.recipe.bakingType = []; //reinit and refill that
			Object.keys(vm.bakingTypes).forEach(function (bakingTypeValue) {
				if (vm.bakingTypes[bakingTypeValue] === true) {
					isSomeValueSet = true;
					vm.recipe.bakingType.push(bakingTypeValue);
				}
			});

			if (isSomeValueSet) {
				vm.addCompletionFeature('bakingType');
			} else {
				vm.removeCompletionFeature('bakingType');
			}
		};

		vm.onTypeChange = function () {
			//do nothing for now
			if (typeof vm.recipe.type !== 'undefined') {
				vm.addCompletionFeature('type');
			} else {
				vm.removeCompletionFeature('type');
			}
		};

		vm.onTitleChange = function () {
			if (vm.recipe.title) {
				vm.addCompletionFeature('title');
			} else {
				vm.removeCompletionFeature('title');
			}
		};

		vm.addCompletionFeature = function (featureName) {
			if (vm.completionFeatures.indexOf(featureName) === -1) {
				vm.completionFeatures.push(featureName);
			}
			vm.recomputeCompletion();
		};

		vm.removeCompletionFeature = function (featureName) {
			var index = vm.completionFeatures.indexOf(featureName);
			if (index > -1) {
				//find the element and remove it
				vm.completionFeatures.splice(index, 1);
			}
			vm.recomputeCompletion();
		};

		vm.recomputeCompletion = function () {
			vm.realCompletion = vm.COMPLETION_STEP * vm.completionFeatures.length;
			vm.currentCompletion = parseInt(vm.realCompletion);

			console.log(vm.currentCompletion);

			vm.widthProgressBar = {
				width: vm.currentCompletion + '%'
			};

			if (vm.currentCompletion === 100) {
				context.set({
					iconCallback: function () {
						//alert.push('success', "OK Passer à l'étape suivante");
						/**var fd = new FormData();
						if (this.myCroppedImage) {
							var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'recipe');
							fd.append('file', fileBuiltFromeBase64);//pass the file newly created
						}
						
						Object.keys(vm.recipe).forEach(function(key) {
							fd.append(key, vm.recipe[key]);
						});**/
						vm.goToStepTwo();

						//TODO switch to next step
						/**$state.go('recipecreationstep', {
							id: vm.recipe.slug,
							step: '2'
						});

						//save using PUT with just the image
						vm.recipe.update(vm.recipe, false).then(function (recipe) {
							//then get the ID and put it into the recipe object :)
							//angular.extend(vm.recipe, recipe);
							//vm.recipe = recipe;
						}, function (error) {
							//TODO treat this case more carefully
							//alert.push('danger', "Le call a échoué veuillez réessayer ultérieurement");
						});**/
					}.bind($scope),
					iconAction: 'arrow-left reversed bigger'
				});
			} else {
				context.set({
					iconCallback: function () {
						vm.formSubmitted = true;
						alert.push('danger', "Veuillez compléter le formulaire pour passer à l'étape suivante");
					},
					iconAction: 'arrow-left reversed bigger'
				});
			}
		};

		context.set({
			goBack: false,
			title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
			contextName: 'Créer ma recette (1/3)',
			iconAction: 'arrow-left reversed bigger',
			iconCallback: function () {
				vm.goToStepTwo();
			}
		});

		var stepNumber = $state.params.step;
		if (stepNumber === '1') {
			context.set({
				title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
				contextName: 'Créer ma recette (1/3)',
				iconAction: 'arrow-left reversed bigger',
				iconCallback: function () {
					vm.formSubmitted = true;
					alert.push('danger', "Veuillez remplir le formulaire pour passer à l'étape suivante");
				}
			});
		} else if (stepNumber === '2') {
			context.set({
				title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
				contextName: 'Créer ma recette (2/3)',
				iconAction: 'arrow-left reversed bigger',
				iconCallback: function () {
					//if there is at least one ingredient save and got next
					vm.goToStepThree();
				}
			});
		} else if (stepNumber === '3') {
			context.set({
				title: "Création de votre recette et calcul automatique de ses apports nutritionnels",
				contextName: 'Créer ma recette (3/3)',
				iconAction: 'arrow-left reversed', //TODO icon for
				iconCallback: function () {
					vm.publishRecipe();
				}
			});
		}

		var WORDING_FOR_THE_NON_RELEVANT_INGREDIENT = 'Les résultats ne sont pas pertinents';

		vm.ingredientsSearchResult = function (ingredientName) {
			vm.ingredientSelectedBackupName = ingredientName;
			//here return a promise
			return ingredientsManager.searchAutocomplete(ingredientName).then(
				function (results) {
					console.log('results of ingredient search', results);
					//only push if at least one result
					if (results.length > 0) {
						results.push({
							word: WORDING_FOR_THE_NON_RELEVANT_INGREDIENT,
							data: [WORDING_FOR_THE_NON_RELEVANT_INGREDIENT]
						});
					}
					//add here a non matched result
					return results;
				},
				function (err) {
					console.log('erreur loading all profiles');
					console.log(err);
				}
			);
		};

		vm.typeaheadOnSelect = function (item, model, label, event, viewValue) {
			//here perform a call to the back end and get more info about this ingredient
			var slugOfIngredient = item.data[0];

			//if click on ingredient non relevant, display the proper thing
			if (slugOfIngredient === WORDING_FOR_THE_NON_RELEVANT_INGREDIENT) {
				vm.ingredientSelected = vm.ingredientSelectedBackupName;
				vm.noResults = true;
			} else {
				//push it in the thread
				vm.ingredientSelected = '';
				ingredientsManager.getQuick(slugOfIngredient).then(function (result) {
					console.log('and the ingredient is', result);
					vm.recipe.ingredientsQuantity.unshift({
						ingredient: result,
						measures: result.measures,
						position: -vm.recipe.unknownIngredientsQuantity.length - vm.recipe.ingredientsQuantity.length
					});
				});
			}

			//then push it to the ingredients list
			//vm.recipe.ingredients
			console.log(item, model, label, event, viewValue);
		};

		vm.onIngredientDelete = function (ingName) {
			var indexObject = vm.recipe.ingredientsQuantity
				.map(function (ingredientQuantity) {
					return ingredientQuantity.ingredient.name;
				})
				.indexOf(ingName);
			vm.recipe.ingredientsQuantity.splice(indexObject, 1);
		};

		vm.onUnkownIngredientDelete = function (ingName) {
			var indexObject = vm.recipe.unknownIngredientsQuantity
				.map(function (ingredientQuantity) {
					return ingredientQuantity.ingredient;
				})
				.indexOf(ingName);
			vm.recipe.unknownIngredientsQuantity.splice(indexObject, 1);
		};

		vm.checkIfAllInstructionsAreOk = function () {
			return vm.recipe.instructions.length > 0;
		};

		vm.checkIfAllIngredientsAreOk = function () {
			var ans = true,
				allingredients = vm.recipe.ingredientsQuantity.concat(vm.recipe.unknownIngredientsQuantity);
			if (allingredients.length > 0) {
				allingredients.forEach(function (ingredientQuantity) {
					ingredientQuantity.isValid =
						ingredientQuantity.ingredient && ingredientQuantity.quantity && ingredientQuantity.measure;
					if (!ingredientQuantity.isValid) {
						ans = false;
					}
				});
			} else {
				ans = false;
			}
			return ans;
		};

		vm.sortIngredientListArray = function (ingredientQuantity, testValue, other) {
			console.log('sortingredients', ingredientQuantity, testValue, other);
			return ingredientQuantity._id || ingredientQuantity.position;
		};

		vm.onAddUnknownIngredient = function () {
			if (!vm.recipe.unknownIngredientsQuantity) {
				//vm.recipe.unknownIngredientsQuantity = [];
				vm.loadMeasures();
			}
			vm.recipe.unknownIngredientsQuantity.unshift({
				ingredient: vm.ingredientSelected,
				position: -vm.recipe.unknownIngredientsQuantity.length - vm.recipe.ingredientsQuantity.length
			});
			//or add measures on the ingredient
		};

		vm.loadMeasures = function () {
			measuresManager.getAll().then(
				function (measures) {
					console.log('measures are ', measures);
					vm.measures = measures.collection;
				},
				function (err) {
					console.log('error loafing all measures');
				}
			);
		};

		vm.getColor = function (ingredientName) {
			var nbColors = INGREDIENTS_COLORS.length,
				toBeReturned = INGREDIENTS_COLORS[0];

			if (ingredientName) {
				var firstLetter = parseInt(ingredientName.charAt(0), 36) - 9;
				if (ingredientName.length > 1) {
					var secondLetter = parseInt(ingredientName.charAt(1), 36) - 9,
						average = (firstLetter + secondLetter) / 2,
						ratio = average / 26; //26 is the number of letters in occidental alphabet
					toBeReturned = INGREDIENTS_COLORS[Math.trunc(ratio * nbColors)];
				} else {
					toBeReturned = INGREDIENTS_COLORS[Math.trunc(firstLetter / 26 * nbColors)];
				}
			}

			console.log(toBeReturned);
			return toBeReturned;
		};

		vm.addInstruction = function () {
			vm.recipe.instructions.push({
				editMode: false,
				instruction: vm.currentInstruction,
				position: vm.currentPosition
			});

			vm.currentInstruction = '';
			vm.currentPosition = vm.recipe.instructions.length + 1;
		};

		vm.removeInstruction = function (index) {
			vm.recipe.instructions.splice(index, 1);
		};

		vm.dragControlListeners = {
			itemMoved: function (event) {
				//Do what you want
				console.log('item moved');
			},
			orderChanged: function (event) {
				//Do what you want
				var previousIndex = event.source.index,
					newIndex = event.dest.index;

				console.log('order has changed from ', previousIndex, 'to', newIndex);
			},
			containment: '#instructions-container'
		};

		vm.goToStepTwo = function () {
			vm.formSubmitted = true;
			if (vm.currentCompletion === 100) {
				//save using PUT with just the image
				vm.recipe.update(vm.recipe, false).then(
					function (recipe) {
						//navigate only when I Have the result back ?
						$state.go('recipecreationstep', {
							id: vm.recipe._id,
							step: '2'
						});
					},
					function (error) {
						//TODO treat this case more carefully
						alert.push('danger', 'Le call a échoué veuillez réessayer ultérieurement');
					}
				);
			} else {
				alert.push('danger', "Veuillez compléter le formulaire pour passer à l'étape suivante");
			}
		};

		vm.goToStepThree = function () {
			if (vm.checkIfAllIngredientsAreOk()) {
				//alert.push('success', "OK passer à l'étape 3");

				vm.recipe.update(vm.recipe, false).then(
					function (recipe) {
						//then get the ID and put it into the recipe object :)
						//angular.extend(vm.recipe, recipe);
						$state.go('recipecreationstep', {
							id: vm.recipe._id,
							step: '3'
						});
						//vm.recipe = recipe;
					},
					function (error) {
						//TODO treat this case more carefully
						alert.push('danger', 'Le call a échoué veuillez réessayer ultérieurement');
					}
				);
			} else {
				vm.showValidity = true;
				alert.push('danger', "Veuillez renseigner les ingrédients pour passer à l'étape suivante");
			}
		};

		vm.goBackToStep = function (number) {
			$state.go('recipecreationstep', {
				id: vm.recipe._id,
				step: number + ''
			});
		};

		vm.publishRecipe = function () {
			//if there is at least one ingredient save and got next
			if (vm.checkIfAllInstructionsAreOk()) {
				vm.recipe.update(vm.recipe, false).then(
					function (recipe) {
						vm.recipe = recipe;
						alert.push('success', 'La recette a été publiée');
						$state.go('recipe', {
							id: vm.recipe.slug
						});
					},
					function () {
						//TODO treat this case more carefully
						alert.push('danger', 'Le call a échoué veuillez réessayer ultérieurement');
					}
				);
			} else {
				vm.showInstructionsValidity = true;
				alert.push('danger', 'Veuillez décrire au moins une instruction');
			}
		};
	}
})();
